var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.36756 0 0 5.36705 0 12C0 18.6325 5.36705 24 12 24C18.6324 24 24 18.633 24 12C24 5.36752 18.633 0 12 0ZM12 22.125C6.40387 22.125 1.875 17.5965 1.875 12C1.875 6.40383 6.40345 1.875 12 1.875C17.5961 1.875 22.125 6.40345 22.125 12C22.125 17.5962 17.5965 22.125 12 22.125Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.105 14.7791L13.3252 11.9993L16.105 9.21956C16.4711 8.85346 16.4711 8.25989 16.105 7.89375C15.7388 7.52761 15.1452 7.52765 14.7792 7.89375L11.9994 10.6735L9.21954 7.89375C8.85349 7.52761 8.25982 7.52761 7.89372 7.89375C7.52763 8.25989 7.52763 8.85346 7.89377 9.21956L10.6736 11.9993L7.89377 14.7791C7.52763 15.1453 7.52758 15.7388 7.89372 16.1049C8.25996 16.4711 8.85354 16.471 9.21954 16.1049L11.9994 13.3252L14.7792 16.1049C15.1452 16.471 15.7389 16.4711 16.105 16.1049C16.4711 15.7388 16.4711 15.1452 16.105 14.7791Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/CancelIcon.4182aa69932ac1f82622132087e3ccc6.svg";
export { ForwardRef as ReactComponent };